import React, {useState, useEffect, useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {RadioGroup, Radio} from "@mui/material";

// Components
import BottomDrawer from "components/WMS/Mobile/BottomDrawer";
import FormControlLabel from "components/radioGroup/FormControlLabel";
import CustomButton from "components/CustomButton";

// API
import {itemNotFound, itemUnavailable} from "api/wms/wmsItems/wmsItems";
import {WMSContext} from "../../../../../../views/wms/context/WMSContext";
import {Authorizations, hasAuthorization} from "../../../../../../utils/authorizations";


UnavailabilityDrawer.propTypes = {
    wmsItem: PropTypes.object.isRequired,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
}

function UnavailabilityDrawer({wmsItem, open = false, handleClose = () => {}}) {
    const NOT_FOUND = 0;
    const UNAVAILABLE = 1;

    const {currentMemberAuthorizations} = useContext(WMSContext);

    const isUserWmsManager = hasAuthorization(currentMemberAuthorizations, Authorizations.WMS_DECLARE_UNAVAILABLE);

    const [choice, setChoice] = useState(null);
    const [loading, setLoading] = useState(false);

    return (
        <BottomDrawer
            open={open}
            onClose={handleClose}
            disablePortal={true}
            openMaxHeight
            noHeightLimit
            title={(<FormattedMessage id='wms.myPickingMissions.popup.product.cancellation.title' />)}
            subtitle={(<FormattedMessage id='wms.myPickingMissions.popup.product.cancellation.subtitle' />)}
        >
            <div>
                <RadioGroup
                    onChange={(event) => setChoice(parseInt(event.target.value))}
                    value={choice}
                >
                    <FormControlLabel
                        value={NOT_FOUND}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            margin: 0,
                            padding: "16px",
                            border: 'unset',
                        }}
                        control={<Radio />}
                        label={<FormattedMessage id='wms.myPickingMissions.popup.product.notfound' /> }
                    />
                    {isUserWmsManager && (
                        <FormControlLabel
                            value={UNAVAILABLE}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                margin: 0,
                                padding: "16px",
                                border: 'unset',
                            }}
                            control={<Radio />}
                            label={<FormattedMessage id='wms.myPickingMissions.popup.product.unavailable' />}
                        />
                    )}
                </RadioGroup>
                <div style={{ padding: "16px" }}>
                    <CustomButton
                        fullWidth
                        loading={loading}
                        disabled={choice === null || loading}
                        onClick={async () => {
                            setLoading(true);

                            if (choice === NOT_FOUND) {
                                await itemNotFound(wmsItem.id).finally(() => setLoading(false))
                            } else if (choice === UNAVAILABLE && isUserWmsManager) {
                                await itemUnavailable(wmsItem.id).finally(() => setLoading(false));
                            }

                            handleClose();
                        }}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.product.cancellation.validate' />
                    </CustomButton>
                </div>
            </div>
        </BottomDrawer>
    )
}

export default UnavailabilityDrawer;
